import React from "react";
import { useLocation } from 'react-router-dom';
import { Box, Tabs, Tab, Stack } from "@mui/material";
import TopSentences from "../component/TopSentences";
import UserLeaderboard from "../component/UserLeaderboard";
import background from '../asset/background-login.png';
import { pageWhiteCardSx } from '../style/pageWhiteCardSx';

export default function Leaderboard() {
    const location = useLocation();
    const initialTab = location.state && location.state.tab ? location.state.tab : 0;
    const [tab, setTab] = React.useState(initialTab);

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'center',
            width: '100%',
            padding: 0,
            backgroundImage: `url(${background})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
        }}>
        <Box
            sx={{
                mt: 2,
                width: '90%',
                p: 2,
                overflow: 'hidden',
                ...pageWhiteCardSx,
            }}
        >
            <Stack spacing={3}>  
                {/* Tab content */}
                <Tabs value={tab} onChange={(_, v) => setTab(v)} centered>
                    <Tab label="Leaderboard" />
                    <Tab label="Top Sentences" />
                </Tabs>

                {tab === 0 && <UserLeaderboard />}
                {tab === 1 && <TopSentences />}
            </Stack>
        </Box>
        </div>
    );
}
